// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    buildCurrency,
    buildNumber
} from '../../../shared/services/build-number';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import {FormattedMessage} from 'react-intl';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';
import {isNotNull} from '../../shared/services/claim-shared-helper';

const ClaimHeaderDetails = props =>
    <div className='claim-header-details'>
        {`${props.claim.claimStatus.value} `}
        {hasAccess(props.security, 'CLAIM', 'CLM_CLAIM_AMOUNTS') &&
            <span className='reimbursement-details'>
                {isNotNull(props.claim.claimValueDetails.reimbursedAmount) && props.claim.claimValueDetails.reimbursedAmount >= 0 &&
                    <span>{`${buildCurrency(props.claim.claimValueDetails.reimbursedAmount)} ${props.claim.claimValueDetails.currency.key} `}</span>
                }
                {props.claim.isApproved && isNotNull(props.claim.claimValueDetails.recoverPercentage) &&
                    <FormattedMessage
                        id='CLAIM_RECOVER_PERCENTAGE'
                        values={{
                            percentage: buildNumber(props.claim.claimValueDetails.recoverPercentage)
                        }}
                    />
                }
            </span>
        }
    </div>;

ClaimHeaderDetails.displayName = 'ClaimHeaderDetails';
ClaimHeaderDetails.propTypes = {
    claim: PropTypes.instanceOf(ClaimSearchResult).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default ClaimHeaderDetails;



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-header-details.js